import { Divider, Grid, Typography } from '@material-ui/core'
import { DocumentLink } from '@src/types/graphql-types'
import { Message } from '@src/utils/messages'
import React, { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { CollapsibleLinks } from './CollapsibleLinks'
import DownloadCertificate from './DownloadCertificate'
import Item from './Item'

export enum DocumentType {
  Certificate = 'CERTIFICATE',
  Vector = 'VECTOR',
}

export const SectionLink = ({
  index,
  classes,
  country,
  language,
  link,
  productNumber,
  isBlueProduct,
  section,
}) => {
  const isBlueProductLink =
    isBlueProduct &&
    (link.key === DocumentType.Certificate || link?.key === DocumentType.Vector)
  return (
    <Grid key={index} item xs={12} className={classes.link}>
      {isBlueProductLink ? (
        <DownloadCertificate link={link} productNumber={productNumber} />
      ) : (
        <Item
          country={country}
          language={language}
          link={link}
          section={section}
          productNumber={productNumber}
        />
      )}
    </Grid>
  )
}

interface ClassesInterface {
  tierSection?: string
  moreDocumentsTitle?: string
  caretIconExpanded: string
}

interface SectionLinksProps {
  message: Message
  sectionLinks: DocumentLink[]
  classes: ClassesInterface
  country: string
  language: string
  productNumber?: string
  isBlueProduct?: boolean
}

export const SectionLinks: React.FC<SectionLinksProps> = ({
  message,
  sectionLinks,
  classes,
  country,
  language,
  productNumber,
  isBlueProduct,
}) => {
  const [expanded, setExpanded] = useState(false)

  const DEFAULT_LIMIT = 10
  const hasExpanded = sectionLinks.length > DEFAULT_LIMIT
  const intl = useIntl()
  return (
    <div className={classes.tierSection}>
      <Typography
        variant="h3"
        component="h3"
        className={classes.moreDocumentsTitle}
      >
        <FormattedMessage {...message} />
      </Typography>

      {sectionLinks
        .slice(0, DEFAULT_LIMIT)
        .sort((a, b) => {
          return a.label < b.label ? -1 : 1
        })
        .map((link, index) => (
          <>
            {link.key !== 'structure_search' && (
              <SectionLink
                index={index}
                country={country}
                language={language}
                link={link}
                classes={classes}
                productNumber={productNumber}
                isBlueProduct={isBlueProduct}
                section={message.defaultMessage.toLowerCase()}
                key={`section-link-${link}-${index}`}
              />
            )}
          </>
        ))}
      <Divider></Divider>
      <CollapsibleLinks
        links={sectionLinks}
        country={country}
        language={language}
        hasExpanded={hasExpanded}
        setExpanded={setExpanded}
        expanded={expanded}
        classes={classes}
        limit={DEFAULT_LIMIT}
        productNumber={productNumber}
        isBlueProduct={isBlueProduct}
        section={intl.formatMessage(message).toLowerCase()}
      />
    </div>
  )
}
